import { atom } from "recoil";

export const printRenderAtom = atom({
	key: "printRender",
	default: undefined,
});
